import { data } from '../../svg/Diagram/data';
import { makeIcon } from '../makeIcon';

export const Diagram = makeIcon(data, 'diagram', 'Diagram');

export default Diagram;
